import { ContractPageData, ContractPageVersion } from '@vy/api-definition';
import { first, vyDate } from '@vy/utils';
import { sortBy } from 'lodash';

export function getContractVersions(contractPageData?: ContractPageData) {
  const versions = contractPageData?.versions ?? [];

  return sortBy(versions, 'createdAt');
}

export function getCurrentPhaseRevisionId(contractVersions: ContractPageVersion[]) {
  const today = vyDate();
  const sortedDatesAsc = contractVersions
    .filter(({ effectiveAt }) => vyDate(effectiveAt).isBefore(today))
    .sort((a, b) => (vyDate(a.effectiveAt).isBefore(vyDate(b.effectiveAt)) ? 1 : -1));

  const firstRevision = first(sortedDatesAsc);

  return firstRevision?.revisionId;
}
